export const INVOICE_PDF_WIDTH = 700;

export enum InvoiceDateRanges {
  AllUninvoiced = 'ALL_UNINVOICED',
  Last7Days = 'LAST_7_DAYS',
  Last15Days = 'LAST_15_DAYS',
  Last30Days = 'LAST_30_DAYS',
  UptoEndDate = 'UPTO_END_DATE',
  Custom = 'CUSTOM',
}

export enum InvoiceLineItemGroups {
  Project = 'PROJECT',
  Phase = 'PHASE',
  Task = 'TASK',
  Role = 'ROLE',
  TeamMember = 'USER',
  TimeEntries = 'DETAILED_TIME_ENTRIES',
  ReimbursedTo = 'EXPENSE_REIMBURSED_TO',
  ExpenseBudget = 'EXPENSE_BUDGET',
  ExpenseCategory = 'EXPENSE_CATEGORY',
  ExpenseReport = 'EXPENSE_REPORT',
  Expense = 'EXPENSE',
  Adhoc = 'ADHOC',
}

export enum InvoiceSourceType {
  Project = 'PROJECT',
}

export enum InvoicedEntityTypes {
  TimeEntry = 'TIME_ENTRY',
  SubscriptionPeriod = 'SUBSCRIPTION_PERIOD',
  Adhoc = 'ADHOC',
  FixedFee = 'FIXED_FEE',
  Expense = 'EXPENSE',
}

export enum InvoiceStatus {
  Draft = 'DRAFT',
  Approved = 'APPROVED',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  PartiallyCredited = 'PARTIALLY_CREDITED',
  Credited = 'CREDITED',
  Voided = 'VOIDED',
  WriteOff = 'WRITE_OFF',
  Deleted = 'DELETED',
  InReview = 'IN_REVIEW',
}

export enum TabNames {
  Comments = 'comments',
  Approvals = 'approvals',
  Payments = 'payments',
  Fields = 'fields',
  Hide = 'hide',
}

export enum InvoiceDisabledText {
  BlankLineOrDescription = 'BlankLineOrDescription',
  BlankTaxColumn = 'BlankTaxColumn',
  ExceededProjectWiseCreditNoteLimit = 'ExceededProjectWiseCreditNoteLimit',
  InvoiceLevelTaxExceeded = 'InvoiceLevelTaxExceeded',
}

export const LINE_SUBTOTAL_ROW = 'SubTotalRow';
export const TAX_ROW = 'TaxRow';
export const LINE_TOTAL_ROW = 'TotalRow';
export const SUBSCRIPTION_TYPE_ROW = 'SubscriptionTypeRow';

export enum DueDateOptionsEnum {
  IssueDate = 'issue_date',
  Days7 = '7_days',
  Days15 = '15_days',
  Days30 = '30_days',
  Days45 = '45_days',
  Days60 = '60_days',
  Days90 = '90_days',
  Custom = 'custom',
}

export enum ApprovalType {
  Individual = 'INDIVIDUAL',
  ApprovalChain = 'APPROVAL_CHAIN',
}

export enum PaymentRecordType {
  Paid = 'PAID',
  WriteOff = 'WRITE_OFF',
  CreditNote = 'CREDIT_NOTE',
}

export enum InvoiceEmailState {
  Published = 'PUBLISHED',
  Draft = 'DRAFT',
}

export enum InvoiceOverdueDurations {
  OneToFifteen = 'ONE_TO_FIFTEEN',
  SixteenToThirty = 'SIXTEEN_TO_THIRTY',
  ThirtyOneToFortyFive = 'THIRTYONE_TO_FORTYFIVE',
  FortyFivePlus = 'FORTYFIVE_PLUS',
}
